var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "minus-o-thick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75,0A7.75,7.75,0,1,0,15.5,7.75,7.76,7.76,0,0,0,7.75,0Zm0,14A6.25,6.25,0,1,1,14,7.75,6.25,6.25,0,0,1,7.75,14ZM11.8,7.75a.76.76,0,0,1-.75.75H4.45a.75.75,0,1,1,0-1.5h6.6A.76.76,0,0,1,11.8,7.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusO);
export default __webpack_public_path__ + "static/media/minus-o.3377ed2018203b9046c31e0104023a36.svg";
export { ForwardRef as ReactComponent };